export default "__VITE_ASSET__8ce1594a__"